App.factory('variantsMatrixService', [function () {
    function VariantsMatrixService() {

        this.determineSingleAndAllLength = function (aScope) {
            if (!angular.isDefined(aScope.lifePackages)) {
                return;
            }

            for (var a = 0; a < aScope.lifePackages.length; a++) {
                if (aScope.lifePackages[a].mandatory) {
                    continue;
                }
                aScope.singleLength[a] = 0;
                let itemsInGroup = aScope.lifePackages[a]["item"].length;
                var itemWeight = 1;
                if (itemsInGroup === 1) {
                    itemWeight = aScope.singleItemGroupWeight;
                }
                for (var b = 0; b < itemsInGroup; b++) {
                    aScope.allLength += itemWeight
                    aScope.singleLength[a] += itemWeight;
                }
            }
        }

        this.determineGroupwidth = function determineGroupwidth(aScope) {
            if (!angular.isDefined(aScope.lifePackages)) return;

            for (var a = 0; a < aScope.lifePackages.length; a++) {
                if (aScope.lifePackages[a].mandatory) {
                    continue;
                }
                aScope.groupwidth[a] = aScope.singleLength[a] / aScope.allLength * 75 + '%';
            }
        }
    }

    return new VariantsMatrixService();
}]);